// Spirit Admin — Business offerings (CMS-lite). Add a service by appending an object.
import { Film, CalendarDays, Scissors, Megaphone, Globe, Zap, Repeat, TrendingUp } from "lucide-react";

export const SERVICES = [
  { icon: Film, label: "Short-Form Content", desc: "Consistent, scroll-stopping short videos for Facebook, TikTok, and other short-form platforms." },
  { icon: CalendarDays, label: "Content Strategy", desc: "A clear monthly plan so you always know what to post — and when — to stay visible." },
  { icon: Scissors, label: "AI-Assisted Editing", desc: "Fast, polished edits that keep your feed active without eating up your week." },
  { icon: Megaphone, label: "Social Media Support", desc: "Captions, hooks, and social-ready delivery across every major platform." },
  { icon: Globe, label: "Website Development", desc: "A clean, modern site for when you're ready to grow beyond social." },
];

export const WHY = [
  { icon: Zap, label: "Fast Delivery", desc: "Quick turnarounds mean your content stays consistent and your feed never goes quiet." },
  { icon: Repeat, label: "Consistent Output", desc: "A reliable stream of on-brand content, handled for you, month after month." },
  { icon: TrendingUp, label: "Designed For Growth", desc: "Content built to keep you visible and growing across every platform." },
];

// Business Inquiries bullets — flexible, no fixed pricing shown.
export const INQUIRY_BULLETS = [
  "Short-form video support",
  "Content planning",
  "Social-ready delivery",
  "AI-assisted editing",
  "Flexible monthly options",
];
